"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zh = exports.ko = exports.ja = exports.fr = exports.es = exports.en = void 0;
const en = require("./en.json");
exports.en = en;
const es = require("./es.json");
exports.es = es;
const fr = require("./fr.json");
exports.fr = fr;
const ja = require("./ja.json");
exports.ja = ja;
const ko = require("./ko.json");
exports.ko = ko;
const zh = require("./zh.json");
exports.zh = zh;
//# sourceMappingURL=index.js.map